<template>
  <span>{{ formattedDate }}</span>
</template>

<script>
export default {
  props: {
    dateValue: {
      type: [String, Date, null],
      default: null,
    },
  },
  data() {
    return {
      formattedDateInternal: ''
    };
  },
  computed: {
    formattedDate() {
      if (this.dateValue === null || this.dateValue === '') {
        return '';
      }

      const date = new Date(this.dateValue);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    }
  },
  watch: {
    dateValue(newValue) {
      this.formattedDateInternal = this.formatDate(newValue);
    }
  },
  mounted() {
    this.formattedDateInternal = this.formatDate(this.dateValue);
  },
  methods: {
    formatDate(value) {
      if (value === null || value === '') {
        return '';
      }

      const date = new Date(value);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/common/DateFormatter.vue